import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderProductKeyAttributeSnapshot } from './OrderProductKeyAttributeSnapshot'
/**
* Class ShowcaseReviewableItemDto
*  Купленный товар без отзыва — для кнопки «Оценить».
*/
export class ShowcaseReviewableItemDto extends ActiveModel {

  /**
  * orderItemId
  * Позиция завершённого заказа.  */
  @ActiveField(0)
  orderItemId: number = 0


  /**
  * productId
  * Купленный вариант.  */
  @ActiveField(0)
  productId: number = 0


/**
  * name
  * Название товара на момент покупки.
  */
  @ActiveField('')
  name: string = ''


/**
  * @property keyAttributes
  * Ключевые атрибуты варианта на момент покупки.  */
  @ActiveField({
    factory: [OrderProductKeyAttributeSnapshot, () => []]
  })
  keyAttributes: Array<OrderProductKeyAttributeSnapshot> = []


/**
  * completedAt
  * Когда позиция стала завершённой.
  */
  @ActiveField('')
  completedAt: string = ''


/**
  * imageIds
  * Изображения купленного варианта на текущей витрине, в порядке показа (как в позициях заказа).  */
  @ActiveField({
    setter(model: ShowcaseReviewableItemDto, prop: string, value: Array<string>, receiver?: ShowcaseReviewableItemDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  imageIds: Array<string> = []
}
